import { render, staticRenderFns } from "./index.vue?vue&type=template&id=432f5b66&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,TrustpilotStars: require('/usr/src/app/components/common-sections/trustpilot-stars.vue').default,Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,ServiceNew: require('/usr/src/app/components/business/service-new.vue').default,NewDocBox: require('/usr/src/app/components/common-sections/new-doc-box.vue').default,TrustpilotReviews: require('/usr/src/app/components/common-sections/trustpilot-reviews.vue').default,FooterCta: require('/usr/src/app/components/common-sections/footer-cta.vue').default,ChecklistModal: require('/usr/src/app/components/business/checklist-modal.vue').default,LnModal: require('/usr/src/app/components/common-sections/ln-modal.vue').default})
